define('page/deps', [
    'utils/common',
], function (common) {
    'use strict';
    common.checkUser()
    common.renderTabTrace()
    common.popupHydrate()
    common.popUpFormHydrate()
    common.Exit()
    common.AllRead()
    common.GetSystemMessageList()
    common.baiduChatHydrate()
    common.listenWindowScroll()
});
